import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer
      style={{
        marginTop: "60px",
        padding: "30px 16px",
        textAlign: "center",
        color: "rgb(197, 176, 55)",
        borderTop: "1px solid rgba(197,176,55,0.3)",
        opacity: 0.8,
      }}
    >
      {/* Grid container for footer links */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
          gap: "16px",
          maxWidth: "1600px",
          margin: "0 auto",
        }}
      >
        {/* Example Footer Card */}
        <div
          className="footer-option"
          onClick={() => navigate("draft")}
          style={{
            background: "linear-gradient(180deg, #111, #000)",
            border: "1px solid rgba(197, 176, 55, 0.5)",
            borderRadius: "10px",
            padding: "20px 10px",
            fontSize: "0.9rem",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(255, 215, 0, 0.15)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow =
              "0 0 15px rgba(255, 215, 0, 0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 0 8px rgba(255, 215, 0, 0.15)";
          }}
        >
          Draft Mode
        </div>

        <div
          className="footer-option"
          onClick={() => navigate("squad-strike")}
          style={{
            background: "linear-gradient(180deg, #111, #000)",
            border: "1px solid rgba(197, 176, 55, 0.5)",
            borderRadius: "10px",
            padding: "20px 10px",
            fontSize: "0.9rem",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(255, 215, 0, 0.15)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow =
              "0 0 15px rgba(255, 215, 0, 0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 0 8px rgba(255, 215, 0, 0.15)";
          }}
        >
          Squad Strike
        </div>

        <div
          className="footer-option"
          onClick={() => navigate("random-mode")}
          style={{
            background: "linear-gradient(180deg, #111, #000)",
            border: "1px solid rgba(197, 176, 55, 0.5)",
            borderRadius: "10px",
            padding: "20px 10px",
            fontSize: "0.9rem",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(255, 215, 0, 0.15)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow =
              "0 0 15px rgba(255, 215, 0, 0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 0 8px rgba(255, 215, 0, 0.15)";
          }}
        >
          Random Mode
        </div>
        <div
          className="footer-option"
          onClick={() => navigate("tournament")}
          style={{
            background: "linear-gradient(180deg, #111, #000)",
            border: "1px solid rgba(197, 176, 55, 0.5)",
            borderRadius: "10px",
            padding: "20px 10px",
            fontSize: "0.9rem",
            cursor: "pointer",
            boxShadow: "0 0 8px rgba(255, 215, 0, 0.15)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow =
              "0 0 15px rgba(255, 215, 0, 0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 0 8px rgba(255, 215, 0, 0.15)";
          }}
        >
          Tournament Mode
        </div>
      </div>
    </footer>
  );
};

export default Footer;
